<template>
  <div>
    <div
      class="modal fade"
      id="modal-apartment-in-group-list"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartmentGroup.apartmentInGroup.title") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-primary pull-right"
                  @click="addNewApartmentInGroup"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-plus"></i>
                  </span>
                  {{ $t("common.addnew") }}
                </button>
              </div>
              <div class="col-md-12" style="margin-top: 15px">
                <b-table
                  :items="gridDataList"
                  :fields="gridColumns"
                  class="mt-3"
                  outlined
                  responsive
                >
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                  <template #cell(actions)="row">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-danger dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="true"
                      >
                        <i class="fa fa-fw fa-ellipsis-h"></i>
                      </button>
                      <ul class="dropdown-menu" style="min-width: 50px">
                        <!-- <li>
                          <button
                            v-if="
                              GET_ACCOUNT_DATA.id == 1 ||
                                has_perm('update_apartment')
                            "
                            class="btn btn-primary btn-sm"
                            style="margin-left: 6px;"
                            @click="onOpenEditInput(row.item)"
                          >
                            <i class="glyphicon glyphicon-edit"></i>
                          </button>
                        </li> -->
                        <li style="margin-top: 5px">
                          <button
                            v-if="
                              GET_ACCOUNT_DATA.id == 1 ||
                                has_perm('delete_apartment_group')
                            "
                            class="btn btn-danger btn-sm"
                            style="margin-left: 6px;"
                            @click="onOpenDelete(row.item)"
                          >
                            <i class="glyphicon glyphicon-trash"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </template>
                </b-table>
                <div class="box-footer clearfix" style="display:contents;">
                  <paginator
                    :totalItem="paginateData.totalItem"
                    :currentPage="paginateData.currentPage"
                    :pageSize="paginateData.pageSize"
                    :totalPage="paginateData.totalPage"
                    @onpaginate="onPagination"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <!-- <button type="button" class="btn btn-primary" @click="onSave">
              {{ $t("common.save") }}
            </button> -->
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!--  -->
    <div
      class="modal fade"
      id="modal-add-apartment-in-group"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("apartmentGroup.apartmentInGroup.addNew") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group required">
                  <label class="control-label" for="">{{
                    $t("customer.apartment_code")
                  }}</label>
                  <v-select
                    class="clear"
                    :clearable="false"
                    :options="apartmentNotInGroup"
                    :reduce="data => data.value"
                    :getOptionLabel="option => $t(option.text)"
                    v-model="apartmentId"
                    :placeholder="$t('customer.apartment_code')"
                  >
                    <template v-slot:option="option">
                      {{ option.text }}
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onAddApartmentInGroup"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!--  -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
import { mapActions, mapGetters } from "vuex";
import utils from '@/lib/utils';
import Loading from "vue-loading-overlay";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
export default {
  components: {
    paginator: Paginator,
    loading: Loading,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert
  },
  data: () => ({
    isLoading: false,
    gridDataList: [],
    gridColumns: [
      {
        label: "common.nonumber",
        key: "nonumber",
        class: "text-center "
      },
      {
        label: "apartment.apartment_code",
        key: "apartmentCode",
        class: "text-center "
      },
      {
        label: "apartment.size",
        key: "apartmentSize",
        class: "text-center "
      },
      {
        label: "customer.owner",
        key: "apartmentOwner",
        class: "text-center "
      },
      {
        label: "customer.headOfAHousehold",
        key: "headOfAHousehold",
        class: "text-center "
      },
      { key: "actions", label: "common.action" }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    apartmentList: [],
    apartmentNotInGroup: [],
    apartmentGroupId: null,
    apartmentId: null,
    isModalVisible: false,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    apartmentInGroupSelect: null
  }),
  watch: {
    GET_APARTMENT_LIST_NO_PAGE_DATA: function() {
      this.apartmentList = [];
      let data = this.GET_APARTMENT_LIST_NO_PAGE_DATA;
      data.forEach(apartment => {
        let item = {
          value: apartment.id,
          text: apartment.apartment_code,
          leasebackService: apartment.leaseback_service
        };
        this.apartmentList.push(item);
      });
    },
    GET_APARTMENT_IN_GROUP_WITH_GROUP_ID_LIST_DATA: function() {
      this.gridDataList = [];
      let data = this.GET_APARTMENT_IN_GROUP_WITH_GROUP_ID_LIST_DATA.results;
      this.apartmentNotInGroup = [];
      let apartmentListClone = [...this.apartmentList];
      data.forEach((e, index) => {
        let nonumber =
          index +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let apartmentCode = e.apartment_info.apartment_code;
        let apartmentSize = e.apartment_info.size;
        let apartmentOwner = "";
        let ownerFilter = e.listResidents.filter(
          x => x.isOwner === true && x.relationship_to == null
        );
        if (ownerFilter.length > 0) {
          apartmentOwner =
            ownerFilter[0].resident.last_name +
            " " +
            ownerFilter[0].resident.first_name;
        }
        let headOfAHousehold = "";
        let headOfAHouseholdFilter = e.listResidents.filter(
          x => x.isTenant && x.relationship_to == null
        );
        if (headOfAHouseholdFilter.length > 0) {
          headOfAHousehold =
            headOfAHouseholdFilter[0].resident.last_name +
            " " +
            headOfAHouseholdFilter[0].resident.first_name;
        }
        let item = {
          id: e.id,
          nonumber: nonumber,
          apartmentCode: apartmentCode,
          apartmentSize: apartmentSize,
          apartmentOwner: apartmentOwner,
          headOfAHousehold: headOfAHousehold
        };
        this.gridDataList.push(item);
        // get apartment not in group
        let apartmentIndex = apartmentListClone.findIndex(
          x => x.value === e.apartment_info.id
        );
        if (apartmentIndex !== -1) {
          apartmentListClone.splice(apartmentIndex, 1);
        }
      });
      this.apartmentNotInGroup = apartmentListClone;
    }
  },
  computed: {
    ...mapGetters([
      "GET_APARTMENT_LIST_NO_PAGE_DATA",
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_IN_GROUP_WITH_GROUP_ID_LIST_DATA",
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    // apartment in group list
    onShowModalApartmentInGroupList: function() {
      $("#modal-apartment-in-group-list").modal("show");
    },
    onHideModalApartmentInGroupList: function() {
      $("#modal-apartment-in-group-list").modal("hide");
    },
    getApartmentInGroup: async function(groupId) {
      this.apartmentGroupId = groupId;
      this.onShowModalApartmentInGroupList();
      await this.getApartmentInGroupList(1);
    },
    getApartmentInGroupList: function(page) {
      let apartmentFilter = {
        params: {
          apartmentGroupId: this.apartmentGroupId,
          page: page
        }
      };
      this.isLoading = true;
      // this.gridDataList = [];
      this.GET_APARTMENT_IN_GROUP_WITH_GROUP_ID_LIST(apartmentFilter)
        .then(
          function(res) {
            this.paginateData.totalItem = res.count;
            this.paginateData.currentPage = res.page;
            this.paginateData.pageSize = res.page_size;
            this.paginateData.totalPage = res.num_pages;
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.gridDataList = [];
            this.isLoading = false;
          }.bind(this)
        );
    },
    onPagination: function(data) {
      this.getApartmentInGroupList(data);
    },
    getApartmentList: function() {
      let apartmentFilter = {
        params: {
          asset: "asset",
          // excludeApartmentInGroup: this.apartmentGroupId
        }
      };
      this.isLoading = true;
      this.GET_APARTMENT_LIST(apartmentFilter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    // add apartment in group
    onShowModalAddApartmentInGroup: function() {
      $("#modal-add-apartment-in-group").modal("show");
    },
    onHideModalAddApartmentInGroup: function() {
      $("#modal-add-apartment-in-group").modal("hide");
    },
    addNewApartmentInGroup: function() {
      this.apartmentId = null;
      this.onShowModalAddApartmentInGroup();
    },
    onAddApartmentInGroup: function() {
      if (utils.isEmptyString(this.apartmentId)) {
        this.showError("customer.apartment_code");
      } else {
        let data = {
          apartmentGroupId: this.apartmentGroupId,
          apartmentId: this.apartmentId
        };
        this.isLoading = true;
        this.POST_APARTMENT_IN_GROUP(data)
          .then(
            function() {
              this.isLoading = false;
              this.SUCCESS_TOAST();
              this.onHideModalAddApartmentInGroup();
              // callback data
              this.getApartmentInGroupList(this.paginateData.currentPage);
            }.bind(this)
          )
          .catch(
            function() {
              this.isLoading = false;
            }.bind(this)
          );
      }
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onOpenDelete: function(data) {
      this.apartmentInGroupSelect = data;
      this.isModalVisible = true;
    },
    onConfirm: function() {
      this.DELETE_APARTMENT_IN_GROUP(this.apartmentInGroupSelect)
        .then(
          function() {
            this.isLoading = false;
            this.SUCCESS_TOAST();
            this.closeModal();
            // callback data
            this.getApartmentInGroupList(this.paginateData.currentPage);
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_APARTMENT_LIST",
      "GET_APARTMENT_IN_GROUP_WITH_GROUP_ID_LIST",
      "POST_APARTMENT_IN_GROUP",
      "DELETE_APARTMENT_IN_GROUP"
    ])
  },
  mounted() {
    // fix show multiple modal
    $(document).on("hidden.bs.modal", ".modal", function() {
      $(".modal:visible").length && $(document.body).addClass("modal-open");
    });
    this.getApartmentList();
  }
};
</script>
<style scoped>
/* .modal {
  text-align: center;
}

.modal:before {
  display: inline-block;
  vertical-align: middle;
  content: " ";
  height: 100%;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
} */
.form-group.required .control-label:after {
  content: " *";
  color: red;
  position: absolute;
  margin-left: 8px;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentGroup/ApartmentInGroupList.vue